/* CSS variables. You need to handle all places where `CSS variables` are marked. */

import { LINE_COLORS } from '@blocksuite/affine-model';
import {
  type AffineCssVariables,
  type AffineTheme,
  cssVar,
} from '@streamlain/theme';
export { cssVar } from '@streamlain/theme';
import { type AffineThemeKeyV2, cssVarV2 } from '@streamlain/theme/v2';
import { unsafeCSS } from 'lit';
export { cssVarV2 } from '@streamlain/theme/v2';
export const ColorVariables = [
  '--streamlain-v2-brand-primary',
  '--streamlain-v2-brand-primary',
  '--streamlain-v2-brand-secondary',
  '--streamlain-v2-layer-background-hoverOverlay',
  '--streamlain-v2-icon-primary',
  '--streamlain-v2-icon-secondary',
  '--streamlain-v2-layer-insideBorder-border',
  '--streamlain-v2-tab-divider-divider',
  '--streamlain-v2-text-placeholder',
  '--streamlain-v2-block-quote-bar',
  '--streamlain-v2-text-link',
  '--streamlain-v2-edgeless-grid',
  '--streamlain-v2-status-success',
  '--streamlain-v2-status-warning',
  '--streamlain-v2-status-error',
  '--streamlain-v2-status-processing',
  '--streamlain-v2-text-emphasis',
  '--streamlain-v2-text-primary',
  '--streamlain-v2-text-secondary',
  '--streamlain-v2-text-disable',
  '--streamlain-v2-layer-blackAlpha-10',
  '--streamlain-v2-layer-blackAlpha-30',
  '--streamlain-v2-layer-blackAlpha-50',
  '--streamlain-v2-layer-blackAlpha-60',
  '--streamlain-v2-layer-blackAlpha-80',
  '--streamlain-v2-layer-blackAlpha-90',
  '--streamlain-v2-layer-black',
  '--streamlain-v2-layer-whiteAlpha-10',
  '--streamlain-v2-layer-whiteAlpha-30',
  '--streamlain-v2-layer-whiteAlpha-50',
  '--streamlain-v2-layer-whiteAlpha-60',
  '--streamlain-v2-layer-whiteAlpha-80',
  '--streamlain-v2-layer-whiteAlpha-90',
  '--streamlain-v2-layer-white',
  '--streamlain-v2-block-code-background',
  '--streamlain-v2-layer-background-tertiary',
  '--streamlain-v2-layer-background-processing',
  '--streamlain-v2-layer-background-error',
  '--streamlain-v2-layer-background-warning',
  '--streamlain-v2-layer-background-success',
  '--streamlain-v2-layer-background-primary',
  '--streamlain-v2-layer-background-secondary',
  '--streamlain-v2-layer-background-modal',
  '--streamlain-v2-layer-background-overlayPanel',
  '--streamlain-tag-blue',
  '--streamlain-tag-green',
  '--streamlain-tag-teal',
  '--streamlain-tag-white',
  '--streamlain-tag-purple',
  '--streamlain-tag-red',
  '--streamlain-tag-pink',
  '--streamlain-tag-yellow',
  '--streamlain-tag-orange',
  '--streamlain-tag-gray',
  ...LINE_COLORS,
  '--streamlain-v2-tooltips-background',
  '--streamlain-blue',
];

export const SizeVariables = [
  '--streamlain-font-h-1',
  '--streamlain-font-h-2',
  '--streamlain-font-h-3',
  '--streamlain-font-h-4',
  '--streamlain-font-h-5',
  '--streamlain-font-h-6',
  '--streamlain-font-base',
  '--streamlain-font-sm',
  '--streamlain-font-xs',
  '--streamlain-line-height',
  '--streamlain-z-index-modal',
  '--streamlain-z-index-popover',
];

export const FontFamilyVariables = [
  '--streamlain-font-family',
  '--streamlain-font-number-family',
  '--streamlain-font-code-family',
];

export const StyleVariables = [
  '--streamlain-editor-width',

  '--streamlain-theme-mode',
  '--streamlain-editor-mode',
  /* --streamlain-palette-transparent: special values added for the sake of logical consistency. */
  '--streamlain-palette-transparent',

  '--streamlain-v2-shadow-popover',
  '--streamlain-v2-shadow-menu',
  '--streamlain-v2-shadow-floatButton',
  '--streamlain-v2-shadow-level1',
  '--streamlain-v2-shadow-level2',
  '--streamlain-v2-shadow-level3',

  '--streamlain-paragraph-space',
  '--streamlain-popover-radius',
  '--streamlain-scale',
  ...SizeVariables,
  ...ColorVariables,
  ...FontFamilyVariables,
] as const;

type VariablesType = typeof StyleVariables;
export type CssVariableName = Extract<
  VariablesType[keyof VariablesType],
  string
>;

export type CssVariablesMap = Record<CssVariableName, string>;

export const unsafeCSSVar = (
  key: keyof AffineCssVariables | keyof AffineTheme,
  fallback?: string
) => unsafeCSS(cssVar(key, fallback));

export const unsafeCSSVarV2 = (key: AffineThemeKeyV2, fallback?: string) =>
  unsafeCSS(cssVarV2(key, fallback));
